import { render } from "./KYC.vue?vue&type=template&id=1ca81968&scoped=true"
import script from "./KYC.vue?vue&type=script&lang=js"
export * from "./KYC.vue?vue&type=script&lang=js"

import "@/views/ClientSpace/custom-clientSpace.scss?vue&type=style&index=0&id=1ca81968&lang=scss&scoped=true"
import "./custom-kyc.scss?vue&type=style&index=1&id=1ca81968&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ca81968"]])

export default __exports__